import Header from "../navigation/headerContainer";
import HomeContainer from "./homeContainer";
import Footer from "../navigation/footerContainer";

export default function Home() {

    return(
        <>
            <Header />
            <HomeContainer />
            <Footer />
        </>
    )
}